/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

import { map, startWith } from 'rxjs/operators';
import { ApiService } from '@app/@core/services';
import { AuthService } from '@app/@core/services/auth/auth.service';
import { MessageService } from "@app/@shared/components/message/message.service";
import { Associate } from '@app/models';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';

import * as Fuse from 'fuse.js';

@Component({
  selector: 'update-profile-dialog',
  templateUrl: './update-profile-dialog.component.html',
  styleUrls: ['./update-profile-dialog.component.scss']
})
export class UpdateProfileDialogComponent implements OnInit, OnDestroy {
  uploadSub: Subscription;

  processing;
  display_photo;
  authForm = this.formBuilder.group({
    'display_name': ['', Validators.required],
  });

  get display_name() { return this.authForm.controls.display_name; }

  constructor (
    @Inject(MAT_DIALOG_DATA) public user: any,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private authService: AuthService,
    private _notification: MessageService,
    public dialogRef: MatDialogRef<UpdateProfileDialogComponent>) {}

  ngOnInit() {
    this.display_name.setValue(this.user.personal.full_name);
    this.display_photo = this.user.display_photo.original;
  }

  ngOnDestroy() {
    if (this.uploadSub) this.uploadSub.unsubscribe();
  }

  resetForm(ref = null) {
    if (!ref) {
      this.authForm.reset();
    } else {
      const form_field = this.authForm.get(ref);
      if (!form_field.validator) return form_field.reset();

      const validator = form_field.validator({} as AbstractControl);
      if (validator && validator.required) form_field.setValue('');
      else form_field.reset();
    }
  }

  submitForm() {
    this.processing = true;
    let authData = this.authForm.value;
    let data: any = {}
    data['display_name'] = authData.display_name;
    // Merge Client
    this.apiService.post('update-profile', data).subscribe((res) => {
      if (!res.error) this.dialogRef.close(res);
      this.processing = false;
    });
  }

  onDropzoneUpload(event) {
    this.processing = true;
    // console.log('DZ selected', event);
    let files: File[] = [];
    files.push(...event.addedFiles);

    let form_data = new FormData();
    for (var i = 0; i < files.length; i++) {
      form_data.append("uploads[]", files[i], files[i].name);
    }

    this.uploadSub = this.apiService.upload("update-display-photo", form_data).subscribe((res) => {
      // console.log("Uploaded files", res);
      if (res.error === false) {
        this._notification.create("success", "Success! Display Photo updated.", { Position: "top", Style: "bar", Duration: 2000 });
        this.authService.user = res["data"];
        this.user = res['data'];
        setTimeout(() => { this.processing = false; });
      }
    });
  }

}